import { observer } from 'mobx-react-lite';
import { Logo } from 'ui/components/Logo/Logo';
import { WaitingApprovalControls } from './parts/WaitingApprovalControls';
import { WaitingApprovalLocalVideo } from './parts/WaitingApprovalLocalVideo';
import { WaitingApprovalRejectActions } from './parts/WaitingApprovalRejectActions';
import type { WaitingApprovalViewModel } from './useWaitingApprovalViewModel';
import {
    BrandLogoWrapper,
    BrandMediaCrossfade,
    BrandRejectedModalActions,
    BrandRejectedModalCard,
    BrandRejectedModalTitle,
    BrandWaitingApprovalRoot,
    BrandWaitingCenterStage,
    BrandWaitingControls,
    BrandWaitingSpinnerIcon,
    BrandWaitingStatusRow,
    BrandWaitingStatusText,
} from './brandWaitingView';

type BrandWaitingApprovalLayoutProps = {
    viewModel: WaitingApprovalViewModel;
};

export const BrandWaitingApprovalState = observer(({ viewModel }: BrandWaitingApprovalLayoutProps) => {
    const { isJoinRejected, layout, localVideoTrack, onRetry, onDismiss, controls, labels } = viewModel;

    if (isJoinRejected) {
        return (
            <BrandWaitingApprovalRoot>
                <BrandWaitingCenterStage>
                    <BrandRejectedModalCard>
                        <BrandLogoWrapper>
                            <Logo />
                        </BrandLogoWrapper>
                        <BrandRejectedModalTitle>{labels.declined}</BrandRejectedModalTitle>
                        <BrandRejectedModalActions>
                            <WaitingApprovalRejectActions
                                variant="brand"
                                retryLabel={labels.retry}
                                dismissLabel={labels.dismiss}
                                onRetry={onRetry}
                                onDismiss={onDismiss}
                            />
                        </BrandRejectedModalActions>
                    </BrandRejectedModalCard>
                </BrandWaitingCenterStage>
            </BrandWaitingApprovalRoot>
        );
    }

    return (
        <BrandWaitingApprovalRoot>
            <BrandWaitingCenterStage>
                <BrandMediaCrossfade $active={layout === 'waiting_placeholder'}>
                    <BrandLogoWrapper>
                        <Logo />
                    </BrandLogoWrapper>
                    <BrandWaitingStatusRow>
                        <BrandWaitingSpinnerIcon icon="icSpinner" colorVariant="bright" size={20} />
                        <BrandWaitingStatusText>{labels.waiting}</BrandWaitingStatusText>
                    </BrandWaitingStatusRow>
                </BrandMediaCrossfade>
                <BrandMediaCrossfade $active={layout === 'video'}>
                    {localVideoTrack && <WaitingApprovalLocalVideo track={localVideoTrack} variant="brand" />}
                </BrandMediaCrossfade>
            </BrandWaitingCenterStage>
            <BrandWaitingControls>
                <WaitingApprovalControls {...controls} onDismiss={onDismiss} />
            </BrandWaitingControls>
        </BrandWaitingApprovalRoot>
    );
});
